import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.program.item');
import { OnInit, OnChanges, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-support-program-item',
template: templateSource || '',
    styles: [``],
})
export class PortalLpsysadminSupportProgramItemComponent implements OnInit, OnChanges {
    @Input() program_id: string = '';
    @Input() menu: string = 'info';
    @Input() detail_id: string = '';   // 운영(milestone) 상세 페이지 진입 시 milestone_id
    @Input() module_type: string = ''; // 모듈 상세 화면 진입 시 module_type

    constructor(@Inject( Service) public service: Service) { }

    public loaded: boolean = false;
    public program: any = null;

    // Tabs
    public tabs = [
        { key: 'info', label: '사업 정보' },
        { key: 'announcements', label: '모집공고' },
        { key: 'applications', label: '신청 기업' },
        { key: 'company_mgmt', label: '기업관리' },
        { key: 'board', label: '게시판' },
        { key: 'calendar', label: '캐린더' },
        { key: 'operations', label: '운영' },
        { key: 'kpi', label: 'KPI' },
        { key: 'budget', label: '예산관리' },
    ];

    // Operation detail (운영 상세 페이지)
    public selectedMilestone: any = null;
    public selectedModule: any = null;
    public phases = [
        { key: 'planning', label: '기획' },
        { key: 'execution', label: '실행' },
        { key: 'closing', label: '종료' },
    ];
    public currentPhase: string = 'planning';
    public phaseDocuments: any[] = [];

    // Edit state
    public edit: any = {};
    public editing: boolean = false;

    // Applications
    public applications: any[] = [];
    public appStatusFilter: string = '';
    public showAppCreate: boolean = false;
    public newApp: any = this._emptyApp();
    public editingApp: any = null;

    // Evaluation panel
    public selectedApp: any = null;
    public evaluations: any[] = [];
    public allEvaluations: any[] = [];
    public evaluationApplications: any[] = [];
    public evaluationResultRowsCache: any[] = [];
    public submittedEvaluationResultCountValue: number = 0;
    public evaluators: any[] = [];
    public evalForm: any = this._emptyEval();
    public evalAssignStage: string = 'doc';
    public selectedEvaluatorIds: any = {};
    public evalAssignmentRequest: any = this._emptyAssignmentRequest();
    public evalAssignmentRequestSaving: boolean = false;
    public showEvaluationRequestEditor: boolean = false;
    public editingEvaluationRequest: any = null;
    public evaluationResultMode: string = 'company';
    public evaluationStageFilter: string = 'doc';
    public evaluationStageFilters: any[] = [
        { key: 'doc', label: '서류선발', desc: '접수/심사중 기업' },
        { key: 'pt', label: '발표평가', desc: '서류통과 기업' },
        { key: 'field', label: '현장평가', desc: '발표통과 기업' },
        { key: 'all', label: '전체', desc: '모든 상태' },
    ];
    public evaluatorDocuments: any = this._normalizeEvaluatorDocuments({});
    public evaluatorDocMode: string = 'provide';
    public evaluatorDocSubmissions: any[] = [];
    public selectedEvaluatorDocSubmission: any = null;
    public showEvaluatorDocEditor: boolean = false;
    public editingEvaluatorDoc: any = null;
    public evaluatorDocForm: any = this._emptyEvaluatorDoc('provide');
    public newEvaluatorDocField: any = { key: '', label: '', type: 'text', required: false, options: '' };
    public evaluatorDocFieldTypes: any[] = [
        { key: 'text', label: '짧은 답변' },
        { key: 'textarea', label: '긴 답변' },
        { key: 'date', label: '날짜' },
        { key: 'number', label: '숫자' },
        { key: 'select', label: '선택' },
        { key: 'checkbox', label: '동의 체크' },
        { key: 'file', label: '파일' },
    ];

    // 평가 항목·배점 (eval criteria)
    public evalCriteria: any[] = [];                  // [{key, label, max_score}]
    public showCriteriaEditor: boolean = false;
    public criteriaDraft: any[] = [];                 // 설정 모달 내 임시 편집용

    // Milestones
    public milestones: any[] = [];
    public showMilestoneCreate: boolean = false;
    public newMilestone: any = this._emptyMilestone();
    public editingMilestone: any = null;

    // Board (게시판)
    public posts: any[] = [];
    public postTypeFilter: string = '';
    public postSearch: string = '';
    public showPostEditor: boolean = false;
    public editingPost: any = null;
    public postForm: any = { program_id: '', title: '', content: '', type: 'notice', pinned: false };
    public selectedPost: any = null;
    public newComment: string = '';

    // Calendar
    public calendarYear: number = new Date().getFullYear();
    public calendarMonth: number = new Date().getMonth() + 1; // 1~12
    public calendarCells: any[] = [];

    public statusMap: any = {
        draft: { label: '준비중', cls: 'bg-zinc-100 text-zinc-600' },
        recruiting: { label: '모집중', cls: 'bg-blue-100 text-blue-700' },
        evaluating: { label: '평가중', cls: 'bg-amber-100 text-amber-700' },
        operating: { label: '운영중', cls: 'bg-emerald-100 text-emerald-700' },
        paused: { label: '일시중지', cls: 'bg-orange-100 text-orange-700' },
        completed: { label: '완료', cls: 'bg-zinc-200 text-zinc-700' },
        closed: { label: '종료', cls: 'bg-zinc-300 text-zinc-700' },
        canceled: { label: '취소', cls: 'bg-red-100 text-red-700' },
    };

    public appStatusMap: any = {
        invited: { label: '초대됨', cls: 'bg-zinc-50 text-zinc-600' },
        drafting: { label: '작성중', cls: 'bg-zinc-100 text-zinc-700' },
        submitted: { label: '접수', cls: 'bg-blue-50 text-blue-700' },
        screening: { label: '심사중', cls: 'bg-amber-50 text-amber-700' },
        doc_passed: { label: '서류통과', cls: 'bg-emerald-50 text-emerald-700' },
        doc_failed: { label: '서류탈락', cls: 'bg-red-50 text-red-700' },
        pt_passed: { label: '발표통과', cls: 'bg-emerald-100 text-emerald-800' },
        pt_failed: { label: '발표탈락', cls: 'bg-red-100 text-red-800' },
        selected: { label: '최종선정', cls: 'bg-emerald-600 text-white' },
        rejected: { label: '최종탈락', cls: 'bg-zinc-500 text-white' },
        waitlist: { label: '예비', cls: 'bg-amber-100 text-amber-700' },
        withdrawn: { label: '철회', cls: 'bg-zinc-100 text-zinc-500' },
    };

    public msStatusMap: any = {
        planned: { label: '예정', cls: 'bg-blue-50 text-blue-700' },
        ongoing: { label: '진행중', cls: 'bg-emerald-50 text-emerald-700' },
        done: { label: '완료', cls: 'bg-zinc-100 text-zinc-700' },
        postponed: { label: '연기', cls: 'bg-amber-50 text-amber-700' },
        canceled: { label: '취소', cls: 'bg-red-50 text-red-700' },
    };

    public msTypeMap: any = {
        event: '행사', recruitment: '모집공고', selection: '선발',
        kickoff: '킥오프',
        diagnosis: '진단', education: '교육', workshop: '워크숍',
        mentoring: '멘토링', networking: '네트워킹',
        site_visit: '현장방문', ir_pitching: 'IR 피칭',
        demoday: '데모데이',
        funding_match: '투자매칭',
        expense_mgmt: '예산집행', survey: '만족도조사',
        company_mgmt: '기업관리', reporting: '보고',
        follow_up: '사후관리',
        midcheck: '중간점검', final: '최종발표', settlement: '정산'
    };

    public async ngOnInit() {
        await this.service.init();
        await this.reload();
    }

    public async ngOnChanges() {
        if (this.program_id) await this.reload();
    }

    private async reload() {
        if (!this.program_id) return;
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call('get', { id: this.program_id });
        if (code != 200) {
            this.service.alert.show({ title: '오류', message: data?.message || '지원사업을 불러올 수 없습니다.', action: '확인' });
            this.service.href('/admin/support/programs');
            return;
        }
        this.program = data.data;
        try {
            if (typeof this.program.extra === 'string') this.program.extra = JSON.parse(this.program.extra || '{}');
            if (!this.program.extra || typeof this.program.extra !== 'object') this.program.extra = {};
        } catch { this.program.extra = {}; }
        this.evaluatorDocuments = this._normalizeEvaluatorDocuments(this.program.extra.evaluator_documents);
        // required_attachments 정규화 (DB에서 문자열/객체로 와도 배열로 강제)
        try {
            let ra: any = this.program && this.program.required_attachments;
            if (typeof ra === 'string') {
                try { ra = JSON.parse(ra); } catch { ra = []; }
            }
            if (!Array.isArray(ra)) ra = [];
            this.program.required_attachments = ra;
        } catch { if (this.program) this.program.required_attachments = []; }
        this.loaded = true;
        await this.service.render();
        // KPI 요약 카드를 상단에 항상 노출하기 위해 로드 (탭 무관)
        try { await this.loadKpis(); } catch { }
        await this.loadTab();
    }

    public async loadTab() {
        if (this.menu === 'modules') {
            await this.loadModuleDetail();
            return;
        }
        if (this.menu === 'applications') await this.loadApplications();
        else if (this.menu === 'company_mgmt') await this.loadSelectedCompanies();
        else if (this.menu === 'operations') {
            if (this.detail_id) await this.loadMilestoneDetail(this.detail_id);
            else await this.loadMilestones();
        }
        else if (this.menu === 'board') await this.loadPosts();
        else if (this.menu === 'calendar') await this.loadCalendar();
        else if (this.menu === 'kpi') await this.loadKpis();
        else if (this.menu === 'budget') await this.loadBudgets();
    }

    // ======================== COMPANY MGMT TAB ========================
    public selectedCompanies: any[] = [];
    public async loadSelectedCompanies() {
        const { code, data } = await wiz.call('list_applications', {
            program_id: this.program_id, status: 'selected'
        });
        if (code == 200) this.selectedCompanies = data.rows || [];
        await this.service.render();
    }
    public openCompanyDetail(app: any) {
        if (!app || !app.id) return;
        this.service.href(`/admin/support/applications/${app.id}`);
    }

    public goTab(key: string) {
        this.menu = key;
        this.detail_id = '';
        this.selectedApp = null;
        this.selectedMilestone = null;
        this.selectedModule = null;
        this.service.href(`/admin/support/programs/${this.program_id}/${key}`);
    }

    // ======================== OPERATION DETAIL (in-page) ========================
    public openMilestoneDetail(m: any) {
        this.service.href(`/admin/support/programs/${this.program_id}/operations/${m.id}`);
    }

    public backToOperations() {
        this.service.href(`/admin/support/programs/${this.program_id}/operations`);
    }

    public async loadMilestoneDetail(milestone_id: string) {
        if (!this.milestones || this.milestones.length === 0) await this.loadMilestones();
        // 연결 모듈 표시를 위해 modules가 비어있으면 로드 (loadMilestones에서 못 받은 경우 보완)
        if (!this.modules || this.modules.length === 0) {
            try { await this.loadModules(); } catch { }
        }
        this.selectedMilestone = (this.milestones || []).find((x: any) => x.id === milestone_id) || null;
        if (!this.selectedMilestone) {
            this.service.alert.show({ title: '오류', message: '운영을 찾을 수 없습니다.', action: '확인' });
            this.backToOperations();
            return;
        }
        // 선발(평가) 마일스톤이면 신청기업/평가위원 함께 로드
        if (this.isSelectionMilestone(this.selectedMilestone)) {
            this.selectedApp = null;
            this.evaluations = [];
            this.evalAssignStage = this.defaultEvaluationStage();
            this.evalAssignmentRequest = this.evaluationAssignmentRequestForStage(this.evalAssignStage);
            await Promise.all([
                this.loadApplications(),
                this.loadEvaluators(),
                this.loadEvalCriteria(),
                this.loadAllEvaluations(),
                this.loadEvaluatorDocSubmissions(),
            ]);
        }
        // 모집공고 유형이면 announcement 로드/동기화
        if (this.isRecruitmentMilestone(this.selectedMilestone)) {
            await this.loadRecruitmentAnnouncement();
        } else {
            this.recruitmentAnnouncement = null;
        }
        // 진단 운영인데 연결된 진단 모듈이 없으면 자동 생성/연결 (전역 템플릿이 자동으로 따라옴)
        try {
            const types = this.milestoneTypes(this.selectedMilestone);
            if (types.indexOf('diagnosis') !== -1 && this.milestoneDiagnosisModules(this.selectedMilestone).length === 0) {
                const r = await wiz.call("ensure_milestone_module", { milestone_id: milestone_id, module_type: 'diagnosis' });
                if (r.code === 200) {
                    await this.loadModules();
                    await this.loadMilestones();
                    this.selectedMilestone = (this.milestones || []).find((x: any) => x.id === milestone_id) || this.selectedMilestone;
                }
            }
        } catch { }
        // 대상 기업(선발된 기업) 라벨 표시용 로드
        await this._loadTargetCompanies();
        await this.switchPhase('planning');
    }

    public isSelectionMilestone(m: any): boolean {
        const types = this.milestoneTypes(m);
        return types.indexOf('selection') !== -1;
    }

    public isRecruitmentMilestone(m: any): boolean {
        if (!m) return false;
        const types = this.milestoneTypes(m);
        return types.indexOf('recruitment') !== -1;
    }

    public isDiagnosisMilestone(m: any): boolean {
        if (!m) return false;
        const types = this.milestoneTypes(m);
        if (types.indexOf('diagnosis') !== -1) return true;
        // 연결 모듈 중 진단 유형이 있어도 노출
        return this.milestoneDiagnosisModules(m).length > 0;
    }

    public milestoneDiagnosisModules(m: any): any[] {
        const ids = this.milestoneModuleIds(m);
        if (!ids || ids.length === 0) return [];
        const all = this.modules || [];
        return ids
            .map((id: string) => all.find((x: any) => x.id === id))
            .filter((x: any) => x && x.module_type === 'diagnosis');
    }

    public milestoneOperationModules(m: any): any[] {
        const ids = this.milestoneModuleIds(m);
        if (!ids || ids.length === 0) return [];
        const excluded = ['recruitment', 'selection', 'diagnosis'];
        return ids
            .map((id: string) => (this.modules || []).find((x: any) => x.id === id))
            .filter((x: any) => x && excluded.indexOf(x.module_type) === -1);
    }

    public moduleDetailComponent(mod: any): string {
        const t = (mod && mod.module_type) || this.module_type || '';
        if (t === 'mentoring') return 'mentoring';
        if (t === 'diagnosis') return 'diagnosis';
        return 'generic';
    }

    public async loadModuleDetail() {
        if (!this.modules || this.modules.length === 0) await this.loadModules();
        this.selectedModule = (this.modules || []).find((x: any) => x.id === this.detail_id) || null;
        if (!this.selectedModule && this.detail_id) {
            this.service.alert.show({ title: '오류', message: '모듈을 찾을 수 없습니다.', action: '확인' });
        }
        await this.service.render();
    }

    public recruitmentAnnouncement: any = null;
    public recruitmentLoading: boolean = false;

    public async loadRecruitmentAnnouncement(force: boolean = false) {
        if (!this.selectedMilestone) { this.recruitmentAnnouncement = null; return; }
        if (this.recruitmentLoading && !force) return;
        this.recruitmentLoading = true;
        await this.service.render();
        try {
            const res = await wiz.call('get_milestone_announcement', { milestone_id: this.selectedMilestone.id });
            if (res.code === 200) {
                this.recruitmentAnnouncement = res.data?.announcement || null;
            } else {
                this.recruitmentAnnouncement = null;
            }
        } catch (e) {
            this.recruitmentAnnouncement = null;
        }
        this.recruitmentLoading = false;
        await this.service.render();
    }

    public recruitmentStatusLabel(status: string): string {
        const m: any = { draft: '작성중', open: '게시중 (접수중)', scheduled: '예정', closed: '마감' };
        return m[status] || status;
    }

    public async copyApplyUrl(slug: string) {
        if (!slug) return;
        const url = `${location.origin}/apply/f/${slug}`;
        try {
            await navigator.clipboard.writeText(url);
            this.service.alert.show({ title: '복사 완료', message: url, action: '확인' });
        } catch {
            this.service.alert.show({ title: '복사 실패', message: url, action: '확인' });
        }
    }

    public async publishAnnouncement() {
        const ann = this.recruitmentAnnouncement;
        if (!ann) return;
        const ok = await this.service.alert.show({
            title: '공고 게시',
            message: `"${ann.title}" 공고를 게시하면 링크를 가진 누구나 신청서를 제출할 수 있습니다. 진행하시겠습니까?`,
            action: '게시', cancel: '취소'
        });
        if (!ok) return;
        const res = await wiz.call('update_announcement_status', { id: ann.id, status: 'open' });
        if (res.code !== 200) {
            this.service.alert.show({ title: '게시 실패', message: res.data?.message || '오류', action: '확인' });
            return;
        }
        await this.loadRecruitmentAnnouncement(true);
        this.service.alert.show({ title: '게시 완료', message: '이제 외부에서 접수가 가능합니다.', action: '확인' });
    }

    public async closeAnnouncement() {
        const ann = this.recruitmentAnnouncement;
        if (!ann) return;
        const ok = await this.service.alert.show({
            title: '접수 마감',
            message: `"${ann.title}" 공고의 접수를 마감하시겠습니까? 이후에는 신청서 제출이 불가합니다.`,
            action: '마감', actionBtn: 'warning', cancel: '취소'
        });
        if (!ok) return;
        const res = await wiz.call('update_announcement_status', { id: ann.id, status: 'closed' });
        if (res.code !== 200) {
            this.service.alert.show({ title: '실패', message: res.data?.message || '오류', action: '확인' });
            return;
        }
        await this.loadRecruitmentAnnouncement(true);
    }

    public async switchPhase(phase: string) {
        this.currentPhase = phase;
        await this.loadPhaseDocuments();
        await this.service.render();
    }

    public async loadPhaseDocuments() {
        if (!this.selectedMilestone) { this.phaseDocuments = []; return; }
        const { code, data } = await wiz.call('list_documents', {
            program_id: this.program_id,
            milestone_id: this.selectedMilestone.id,
            phase: this.currentPhase,
        });
        this.phaseDocuments = (code === 200 ? (data.rows || []) : []);
        await this.service.render();
    }

    public async openPhaseDocCreate(docType: string) {
        await this.openDocCreate(docType);
        // 추가 컨텍스트 주입
        if (this.selectedMilestone) {
            this.docForm.module_id = this.selectedMilestone.module_id || '';
            this.docForm.extra = {
                milestone_id: this.selectedMilestone.id,
                phase: this.currentPhase,
                milestone_title: this.selectedMilestone.title,
            };
        }
        await this.service.render();
    }

    public async openPhaseDocEdit(d: any) {
        await this.openDocEdit(d);
    }

    public async submitPhaseDoc() {
        // 기존 submitDoc 사용 (extra에 phase/milestone_id 포함되어 저장)
        await this.submitDoc();
        await this.loadPhaseDocuments();
    }

    public statusInfo(s: string) { return this.statusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' }; }
    public appStatusInfo(s: string) { return this.appStatusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' }; }
    public msStatusInfo(s: string) { return this.msStatusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' }; }

    public formatMoney(n: any): string { return (Number(n) || 0).toLocaleString(); }

    // ======================== INFO TAB ========================

    public startEdit() {
        this.edit = JSON.parse(JSON.stringify(this.program || {}));
        // 분야 선택 UI 초기화 (기존 데이터가 옥션에 없으면 직접입력 모드)
        if (this.edit.category && this.categoryOptions.indexOf(this.edit.category) < 0) {
            this.edit._categorySelect = '__custom__';
        } else {
            this.edit._categorySelect = this.edit.category || '';
        }
        this.editing = true;
        this.service.render();
    }

    public cancelEdit() {
        this.editing = false;
        this.edit = {};
        this.service.render();
    }

    public async saveEdit() {
        const payload: any = { ...this.edit };
        delete payload.stats;
        delete payload.app_count;
        delete payload.selected_count;
        delete payload._categorySelect;
        // 자동 계산 필드는 저장 제외 (backend에서도 다시 걸러냄)
        delete payload.total_budget;
        delete payload.selection_count;
        delete payload.apply_start;
        ['apply_end','program_start','program_end'].forEach(k => {
            if (!payload[k]) payload[k] = null;
        });
        payload.per_company_budget = Number(payload.per_company_budget) || 0;
        // FN-0040: required_attachments 정리 (key/label 비어있는 항목 제거)
        if (Array.isArray(payload.required_attachments)) {
            payload.required_attachments = payload.required_attachments
                .filter((r: any) => r && r.key && r.label)
                .map((r: any) => ({ key: String(r.key).trim(), label: String(r.label).trim(), required: !!r.required }));
        }
        const { code, data } = await wiz.call('update', { id: this.program_id, data: JSON.stringify(payload) });
        if (code != 200) {
            this.service.alert.show({ title: '저장 실패', message: data?.message || '오류', action: '확인' });
            return;
        }
        this.editing = false;
        await this.reload();
    }

    // FN-0040: required_attachments 편집
    public addRequiredAttachment() {
        if (!this.edit.required_attachments) this.edit.required_attachments = [];
        this.edit.required_attachments.push({ key: '', label: '', required: false });
        this.service.render();
    }
    public removeRequiredAttachment(i: number) {
        if (!this.edit.required_attachments) return;
        this.edit.required_attachments.splice(i, 1);
        this.service.render();
    }

    // ======================== APPLICATIONS TAB ========================

    private _emptyApp() {
        return {
            program_id: '', company_name: '', registed_number: '',
            ceo_name: '', ceo_email: '', ceo_phone: '',
            business_area: '', employee_count: 0, revenue: 0,
            requested_amount: 0, summary: '', status: 'submitted',
            _attachments: [] as any[],
        };
    }

    // FN-0040: 신청 폼 첨부파일 핸들링 (등록 후 application_id 결정 → 업로드)
    public async onAppFileChange(event: any, attachKey: string) {
        const file: File = event?.target?.files?.[0];
        event.target.value = '';
        if (!file) return;
        // 등록 전이면 임시 보관, 등록 후 일괄 업로드
        if (!this.newApp._tempFiles) this.newApp._tempFiles = [];
        // 동일 key가 있으면 교체
        if (attachKey) {
            this.newApp._tempFiles = this.newApp._tempFiles.filter((f: any) => f.key !== attachKey);
        }
        this.newApp._tempFiles.push({ key: attachKey, file });
        // 표시용 메타도 _attachments에 미리 넣기
        this.newApp._attachments = this.newApp._attachments.filter((a: any) => !attachKey || a.key !== attachKey);
        this.newApp._attachments.push({
            key: attachKey,
            original_name: file.name,
            stored_name: 'pending:' + file.name + ':' + Date.now(),
            size: file.size,
            _pending: true,
        });
        await this.service.render();
    }

    public getAppAttachByKey(key: string): any {
        return (this.newApp._attachments || []).find((a: any) => a.key === key);
    }

    public getAppExtraAttaches(): any[] {
        return (this.newApp._attachments || []).filter((a: any) => !a.key);
    }

    public removeAppFileLocal(key: string) {
        this.newApp._attachments = (this.newApp._attachments || []).filter((a: any) => a.key !== key);
        if (this.newApp._tempFiles) {
            this.newApp._tempFiles = this.newApp._tempFiles.filter((f: any) => f.key !== key);
        }
        this.service.render();
    }

    public removeAppFileLocalByName(stored_name: string) {
        this.newApp._attachments = (this.newApp._attachments || []).filter((a: any) => a.stored_name !== stored_name);
        // _tempFiles는 key 매칭이 안되면 스킵 (key 없는 파일 식별 어려움)
        if (this.newApp._tempFiles) {
            this.newApp._tempFiles = this.newApp._tempFiles.filter((f: any, idx: number) => {
                // file 이름으로 매칭
                return !stored_name.includes(':' + f.file.name + ':');
            });
        }
        this.service.render();
    }

    public async loadApplications() {
        const statusFilter = this.isSelectionEvaluationContext()
            ? this.selectionApplicationStatusFilter()
            : this.appStatusFilter;
        const { code, data } = await wiz.call('list_applications', {
            program_id: this.program_id, status: statusFilter
        });
        if (code == 200) {
            this.applications = data.rows || [];
            if (!this.isSelectionEvaluationContext()) this.evaluationApplications = this.applications;
            this.refreshEvaluationResultRows();
        }
        await this.service.render();
    }

    private isSelectionEvaluationContext(): boolean {
        return this.menu === 'operations' && !!this.selectedMilestone && this.isSelectionMilestone(this.selectedMilestone);
    }

    private selectionApplicationStatusFilter(): string {
        const map: any = {
            doc: ['submitted', 'screening', 'doc_passed', 'doc_failed', 'selected'],
            pt: ['doc_passed', 'pt_passed', 'pt_failed', 'selected'],
            field: ['pt_passed', 'selected'],
            all: [],
        };
        const statuses = map[this.evaluationStageFilter] || map.doc;
        return statuses.length ? statuses.join(',') : '';
    }

    private defaultEvaluationStage(): string {
        return this.evaluationStageFilter === 'all' ? 'doc' : this.evaluationStageFilter;
    }

    public async setEvaluationStageFilter(stage: string) {
        this.evaluationStageFilter = ['doc', 'pt', 'field', 'all'].indexOf(stage) >= 0 ? stage : 'doc';
        if (this.evaluationStageFilter !== 'all') this.evalAssignStage = this.evaluationStageFilter;
        this.selectedApp = null;
        this.evaluations = [];
        this.selectedEvaluatorIds = {};
        this.evalAssignmentRequest = this.evaluationAssignmentRequestForStage(this.evalAssignStage);
        await this.loadApplications();
    }

    public selectionStatusActions(app: any): any[] {
        const stage = this.evaluationStageFilter === 'all' ? this.evalAssignStage : this.evaluationStageFilter;
        if (stage === 'pt') {
            return [
                { status: 'pt_passed', label: '발표통과' },
                { status: 'pt_failed', label: '발표탈락' },
                { status: 'selected', label: '바로 선발' },
            ].filter((a: any) => a.status !== app?.status);
        }
        if (stage === 'field') {
            return [
                { status: 'selected', label: '최종선정' },
                { status: 'rejected', label: '최종탈락' },
            ].filter((a: any) => a.status !== app?.status);
        }
        return [
            { status: 'doc_passed', label: '서류통과' },
            { status: 'doc_failed', label: '서류탈락' },
            { status: 'selected', label: '바로 선발' },
        ].filter((a: any) => a.status !== app?.status);
    }

    public async setSelectionAppStatus(app: any, status: string) {
        const changed = await this.setAppStatus(app, status);
        if (!changed) return;
        if (this.selectedApp?.id === app.id) {
            this.selectedApp = this.applications.find((x: any) => x.id === app.id) || { ...this.selectedApp, status };
        }
        await this.loadAllEvaluations();
    }

    public openAppCreate() {
        this.newApp = this._emptyApp();
        this.newApp.program_id = this.program_id;
        this.showAppCreate = true;
        this.service.render();
    }

    public closeAppCreate() {
        this.showAppCreate = false;
        this.service.render();
    }

    public async submitAppCreate() {
        try {
            console.log('[submitAppCreate] start', this.newApp);
            if (!this.newApp || !this.newApp.company_name) {
                this.service.alert.show({ title: '입력 오류', message: '기업명을 입력하세요.', action: '확인' });
                return;
            }
            // FN-0040: 필수 첨부 검증
            const required = ((this.program && this.program.required_attachments) || []).filter((r: any) => r && r.required);
            for (const req of required) {
                if (!this.getAppAttachByKey(req.key)) {
                    this.service.alert.show({ title: '첨부 누락', message: `필수 첨부: ${req.label}`, action: '확인' });
                    return;
                }
            }
            const payload: any = { ...this.newApp };
            delete payload._attachments; delete payload._tempFiles;
            payload.employee_count = Number(payload.employee_count) || 0;
            payload.revenue = Number(payload.revenue) || 0;
            payload.requested_amount = Number(payload.requested_amount) || 0;
            if (!payload.program_id) payload.program_id = this.program_id;
            console.log('[submitAppCreate] calling create_application', payload);
            const { code, data } = await wiz.call('create_application', { data: JSON.stringify(payload) });
            console.log('[submitAppCreate] response', code, data);
            if (code != 200) {
                this.service.alert.show({ title: '등록 실패', message: (data && data.message) || `오류 (HTTP ${code})`, action: '확인' });
                return;
            }
            const newId = data.id;
            // 첨부파일 업로드 (순차)
            const tempFiles = (this.newApp && this.newApp._tempFiles) || [];
            for (const tf of tempFiles) {
                const fd = new FormData();
                fd.append('application_id', newId);
                fd.append('attach_key', tf.key || '');
                fd.append('file', tf.file);
                try {
                    await fetch(`/wiz/api/portal.lpsysadmin.support.program.item/upload_application_file`, {
                        method: 'POST', body: fd, credentials: 'include',
                    });
                } catch (e) { console.warn('[submitAppCreate] upload failed', e); }
            }
            this.showAppCreate = false;
            await this.loadApplications();
            await this.service.render();
            this.service.alert.show({ title: '등록 완료', message: '신청 기업이 등록되었습니다.', action: '확인' });
        } catch (e: any) {
            console.error('[submitAppCreate] error', e);
            this.service.alert.show({ title: '오류', message: (e && e.message) || String(e), action: '확인' });
        }
    }

    public async setAppStatus(app: any, newStatus: string): Promise<boolean> {
        const { code, data } = await wiz.call('update_application_status', { id: app.id, status: newStatus });
        if (code != 200) {
            this.service.alert.show({ title: '상태 변경 실패', message: data?.message || '오류', action: '확인' });
            return false;
        }
        const selectedId = this.selectedApp?.id;
        await this.loadApplications();
        if (selectedId) {
            this.selectedApp = this.applications.find((x: any) => x.id === selectedId) || this.selectedApp;
        }
        return true;
    }

    public async deleteApp(app: any) {
        const ok = await this.service.alert.show({
            title: '신청 삭제', message: `"${app.company_name}" 신청을 삭제하시겠습니까?`,
            action: '삭제', actionBtn: 'error', cancel: '취소'
        });
        if (!ok) return;
        await wiz.call('delete_application', { id: app.id });
        if (this.selectedApp?.id === app.id) this.selectedApp = null;
        await this.loadApplications();
    }

    public async recalcRanks() {
        await wiz.call('recalc_ranks', { program_id: this.program_id });
        await this.loadApplications();
        this.service.alert.show({ title: '완료', message: '점수에 따라 순위가 재계산되었습니다.', action: '확인' });
    }

    // ======================== EVALUATIONS TAB ========================

    private _emptyEval() {
        return {
            program_id: '', application_id: '', evaluator_id: '',
            stage: 'doc', score: 0, scores: {}, comment: '', status: 'submitted'
        };
    }

    private _emptyAssignmentRequest() {
        return { documents: '', note: '' };
    }

    private _normalizeAssignmentRequest(req: any): any {
        return {
            documents: req?.documents || req?.request_documents || '',
            note: req?.note || req?.request_note || '',
            title: req?.title || req?.request_title || '',
        };
    }

    private _hasAssignmentRequestValue(req: any): boolean {
        return !!((req?.documents || '').trim() || (req?.note || '').trim() || (req?.title || '').trim());
    }

    private evaluationAssignmentRequestForStage(stage: string = this.evalAssignStage): any {
        const extra = (this.program && this.program.extra && typeof this.program.extra === 'object') ? this.program.extra : {};
        const requests = (extra.assignment_requests && typeof extra.assignment_requests === 'object') ? extra.assignment_requests : {};
        return this._normalizeAssignmentRequest(requests[stage] || extra.assignment_request || {});
    }

    // 을 평가 상세/수정 시 기존 기록의 scores 를 폼으로 로드
    public loadEvalIntoForm(ev: any) {
        this.evalForm = {
            program_id: this.program_id,
            application_id: this.selectedApp?.id || '',
            evaluator_id: ev.evaluator_id || '',
            stage: ev.stage || 'doc',
            score: ev.score || 0,
            scores: ev.scores ? { ...(ev.scores) } : {},
            comment: ev.comment || '',
            status: ev.status || 'submitted',
        };
        this.service.render();
    }

    // 항목별 입력 합계 / 제한
    public criterionScore(key: string): number {
        const v = this.evalForm?.scores?.[key];
        const n = Number(v);
        return isNaN(n) ? 0 : n;
    }

    public setCriterionScore(key: string, value: any, maxScore: number) {
        if (!this.evalForm.scores) this.evalForm.scores = {};
        let n = Number(value);
        if (isNaN(n) || n < 0) n = 0;
        if (typeof maxScore === 'number' && maxScore > 0 && n > maxScore) n = maxScore;
        this.evalForm.scores[key] = n;
    }

    public evalRawTotal(): number {
        let t = 0;
        for (const c of this.evalCriteria || []) {
            t += this.criterionScore(c.key);
        }
        return Math.round(t * 100) / 100;
    }

    public evalMaxTotal(): number {
        let t = 0;
        for (const c of this.evalCriteria || []) {
            t += Number(c.max_score) || 0;
        }
        return t;
    }

    public evalNormalizedTotal(): number {
        const mx = this.evalMaxTotal();
        if (!mx) return 0;
        return Math.round(this.evalRawTotal() / mx * 10000) / 100;
    }

    public async selectAppForEval(app: any) {
        this.selectedApp = app;
        this.evalForm = this._emptyEval();
        this.evalForm.program_id = this.program_id;
        this.evalForm.application_id = app.id;
        this.evalAssignStage = this.defaultEvaluationStage();
        this.selectedEvaluatorIds = {};
        this.evalAssignmentRequest = this.evaluationAssignmentRequestForStage(this.evalAssignStage);
        await Promise.all([
            this.loadEvaluations(app.id),
            this.loadEvaluators(),
            this.loadEvalCriteria(),
        ]);
    }

    public clearSelectedApp() {
        this.selectedApp = null;
        this.evaluations = [];
        this.service.render();
    }

    public async loadEvaluations(appId: string) {
        const { code, data } = await wiz.call('list_evaluations', { application_id: appId });
        if (code == 200) {
            this.evaluations = data.rows || [];
        }
        await this.service.render();
    }

    public async loadAllEvaluations() {
        const [evalRes, appRes] = await Promise.all([
            wiz.call('list_evaluations', { program_id: this.program_id }),
            wiz.call('list_applications', { program_id: this.program_id, status: '' }),
        ]);
        if (appRes.code == 200) {
            this.evaluationApplications = appRes.data.rows || [];
        }
        if (evalRes.code == 200) {
            this.allEvaluations = evalRes.data.rows || [];
            this.refreshEvaluationResultRows();
        }
        await this.service.render();
    }

    public async loadEvaluators() {
        const { code, data } = await wiz.call('list_evaluators');
        if (code == 200) {
            this.evaluators = data.rows || [];
        }
        await this.service.render();
    }

    public evalStatusInfo(status: string): any {
        const map: any = {
            pending: { label: '미제출', cls: 'bg-zinc-100 text-zinc-600' },
            submitted: { label: '제출', cls: 'bg-emerald-50 text-emerald-700' },
            rejected: { label: '반려', cls: 'bg-red-50 text-red-700' },
        };
        return map[status || 'pending'] || { label: status || '-', cls: 'bg-zinc-100 text-zinc-600' };
    }

    public evalStageLabel(stage: string): string {
        return stage === 'doc' ? '서류' : (stage === 'pt' ? '발표' : '현장');
    }

    public evaluationItemScore(ev: any, c: any): any {
        if (!ev || ev.status !== 'submitted') return '-';
        const v = ev.scores && ev.scores[c.key];
        return (v === undefined || v === null || v === '') ? 0 : v;
    }

    public evaluationScore(ev: any): any {
        if (!ev || ev.status !== 'submitted') return '-';
        return ev.score || 0;
    }

    public onEvalAssignStageChange() {
        this.selectedEvaluatorIds = {};
        this.evalAssignmentRequest = this.evaluationAssignmentRequestForStage(this.evalAssignStage);
        this.service.render();
    }

    public assignedEvaluation(evaluatorId: string, stage: string = this.evalAssignStage): any {
        return (this.evaluations || []).find((ev: any) => ev.evaluator_id === evaluatorId && (ev.stage || 'doc') === stage);
    }

    public isEvaluatorSelected(evaluatorId: string): boolean {
        return !!this.selectedEvaluatorIds[evaluatorId];
    }

    public toggleEvaluatorSelection(evaluatorId: string, checked: boolean) {
        if (checked) this.selectedEvaluatorIds[evaluatorId] = true;
        else delete this.selectedEvaluatorIds[evaluatorId];
        this.service.render();
    }

    public selectedEvaluatorCount(): number {
        return Object.keys(this.selectedEvaluatorIds || {}).filter((id: string) => !!this.selectedEvaluatorIds[id]).length;
    }

    public clearEvaluatorSelection() {
        this.selectedEvaluatorIds = {};
        this.service.render();
    }

    public assignmentRequest(ev: any): any {
        const req = ev?.assignment_request || ev?.extra?.assignment_request || {};
        const normalized = this._normalizeAssignmentRequest(req);
        return this._hasAssignmentRequestValue(normalized) ? normalized : this.evaluationAssignmentRequestForStage(ev?.stage || this.evalAssignStage);
    }

    public hasAssignmentRequest(ev: any): boolean {
        const req = this.assignmentRequest(ev);
        return !!((req.documents || '').trim() || (req.note || '').trim());
    }

    public requestDocumentLines(value: any): string[] {
        return String(value || '').split('\n').map((v: string) => v.trim()).filter((v: string) => !!v);
    }

    public evalAssignmentRequestSummary(): string {
        const req = this.evalAssignmentRequest || {};
        const docs = String(req.documents || '').split('\n').map((v: string) => v.trim()).filter((v: string) => !!v);
        if (docs.length > 0) return `요청서류 ${docs.length}건`;
        if ((req.note || '').trim()) return '요청사항 있음';
        return '요청 없음';
    }

    public async saveEvalAssignmentRequest() {
        if (this.evalAssignmentRequestSaving) return;
        this.evalAssignmentRequestSaving = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('update_evaluation_assignment_request', {
                program_id: this.program_id,
                stage: this.evalAssignStage,
                request: JSON.stringify(this.evalAssignmentRequest || {}),
            });
            if (code != 200) {
                this.service.alert.show({ title: '저장 실패', message: data?.message || '공통 요청자료 저장에 실패했습니다.', action: '확인' });
                return;
            }
            const result = data?.result || {};
            this.evalAssignmentRequest = this._normalizeAssignmentRequest(result.request || this.evalAssignmentRequest);
            if (!this.program.extra || typeof this.program.extra !== 'object') this.program.extra = {};
            if (!this.program.extra.assignment_requests || typeof this.program.extra.assignment_requests !== 'object') this.program.extra.assignment_requests = {};
            this.program.extra.assignment_requests[this.evalAssignStage] = { ...this.evalAssignmentRequest };
            if (this.selectedApp?.id) await this.loadEvaluations(this.selectedApp.id);
            await this.loadAllEvaluations();
            this.service.alert.show({ title: '저장 완료', message: `현재 배정 ${result.updated || 0}건에 반영했습니다.`, action: '확인' });
        } finally {
            this.evalAssignmentRequestSaving = false;
            await this.service.render();
        }
    }

    public openEvaluationRequestEditor(ev: any) {
        this.editingEvaluationRequest = ev;
        this.evalAssignmentRequest = { ...this.assignmentRequest(ev) };
        this.showEvaluationRequestEditor = true;
        this.service.render();
    }

    public closeEvaluationRequestEditor() {
        this.showEvaluationRequestEditor = false;
        this.editingEvaluationRequest = null;
        this.evalAssignmentRequest = this._emptyAssignmentRequest();
        this.service.render();
    }

    public async saveEvaluationRequest() {
        const ev = this.editingEvaluationRequest;
        if (!ev || !this.selectedApp) return;
        const { code, data } = await wiz.call('upsert_evaluation', {
            data: JSON.stringify({
                program_id: this.program_id,
                application_id: this.selectedApp.id,
                evaluator_id: ev.evaluator_id,
                stage: ev.stage || 'doc',
                request: { ...this.evalAssignmentRequest },
            }),
        });
        if (code != 200) {
            this.service.alert.show({ title: '저장 실패', message: data?.message || '요청사항 저장에 실패했습니다.', action: '확인' });
            return;
        }
        this.closeEvaluationRequestEditor();
        await this.loadEvaluations(this.selectedApp.id);
    }

    public async assignSelectedEvaluators() {
        if (!this.selectedApp) return;
        const evaluatorIds = Object.keys(this.selectedEvaluatorIds || {}).filter((id: string) => !!this.selectedEvaluatorIds[id]);
        if (evaluatorIds.length === 0) {
            this.service.alert.show({ title: '입력 오류', message: '추가할 평가위원을 선택하세요.', action: '확인' });
            return;
        }
        const { code, data } = await wiz.call('assign_evaluators', {
            program_id: this.program_id,
            application_id: this.selectedApp.id,
            evaluator_ids: JSON.stringify(evaluatorIds),
            stage: this.evalAssignStage,
            request: JSON.stringify({}),
        });
        if (code != 200) {
            this.service.alert.show({ title: '추가 실패', message: data?.message || '평가위원 추가에 실패했습니다.', action: '확인' });
            return;
        }
        const result = data?.result || {};
        const created = result.created?.length || 0;
        const existing = result.existing?.length || 0;
        const invalid = result.invalid || [];
        if (invalid.length > 0 && created === 0 && existing === 0) {
            this.service.alert.show({ title: '추가 실패', message: `활성 평가위원이 아닙니다: ${invalid.join(', ')}`, action: '확인' });
            return;
        }
        this.selectedEvaluatorIds = {};
        this.evalAssignmentRequest = this.evaluationAssignmentRequestForStage(this.evalAssignStage);
        await this.loadEvaluations(this.selectedApp.id);
        await this.loadAllEvaluations();
        await this.loadApplications();
        this.service.alert.show({
            title: '추가 완료',
            message: `신규 ${created}명, 기존 배정 ${existing}명${invalid.length ? `, 제외 ${invalid.length}명` : ''}`,
            action: '확인'
        });
    }

    // ---- 평가위원 요청 서류 및 자료 ----
    private _defaultEvaluatorFields(): any[] {
        return [
            { key: 'evaluator_name', label: '성명', type: 'text', required: true },
            { key: 'affiliation', label: '소속/직위', type: 'text', required: true },
            { key: 'phone', label: '연락처', type: 'text', required: false },
            { key: 'email', label: '이메일', type: 'text', required: false },
            { key: 'confidentiality_consent', label: '평가자료 비밀유지에 동의합니다', type: 'checkbox', required: true },
            { key: 'conflict_check', label: '이해관계 여부 및 회피 사유', type: 'textarea', required: false },
        ];
    }

    private _defaultEvaluatorDocuments(): any {
        return {
            provide: [
                {
                    id: 'evaluator_guide',
                    title: '평가위원 안내 자료',
                    description: '평가 기준, 일정, 유의사항 안내',
                    content: '평가위원은 배정된 신청기업의 제출자료를 검토하고 정해진 평가 항목에 따라 점수와 의견을 제출합니다.',
                    attachments: [],
                    status: 'published',
                },
            ],
            request: [
                {
                    id: 'evaluator_basic_confirm',
                    title: '평가위원 확인서 및 비밀유지 동의',
                    description: '평가 진행 전 확인이 필요한 기본정보와 동의 항목입니다.',
                    required: true,
                    status: 'active',
                    attachments: [],
                    fields: this._defaultEvaluatorFields(),
                },
            ],
        };
    }

    private _normalizeEvaluatorDocuments(raw: any): any {
        const base = raw && typeof raw === 'object' ? raw : this._defaultEvaluatorDocuments();
        if (!Array.isArray(base.provide)) base.provide = [];
        if (!Array.isArray(base.request)) base.request = [];
        for (const d of [...base.provide, ...base.request]) {
            d.attachments = this._normalizeEvaluatorDocAttachments(d.attachments);
            if (d.fields && !Array.isArray(d.fields)) d.fields = [];
            if (Array.isArray(d.fields)) d.fields = this._normalizeEvaluatorDocFields(d.fields, false);
        }
        return base;
    }

    private _normalizeEvaluatorDocAttachments(attachments: any): any[] {
        if (!Array.isArray(attachments)) return [];
        return attachments.map((a: any) => ({
            name: a?.name || a?.file_name || a?.original_name || '',
            url: a?.url || a?.file_url || '',
            original_name: a?.original_name || a?.name || '',
        }));
    }

    private _normalizeEvaluatorDocFields(fields: any, fillKey: boolean = true): any[] {
        if (!Array.isArray(fields)) return [];
        const fieldTypes = Array.isArray(this.evaluatorDocFieldTypes)
            ? this.evaluatorDocFieldTypes
            : [{ key: 'text' }, { key: 'textarea' }, { key: 'date' }, { key: 'number' }, { key: 'select' }, { key: 'checkbox' }, { key: 'file' }];
        const used: any = {};
        const out: any[] = [];
        for (let i = 0; i < fields.length; i++) {
            const f = fields[i] || {};
            const label = String(f.label || '').trim();
            let key = String(f.key || '').trim();
            if (!label && !key) continue;
            if (!key && fillKey) key = this._nextEvaluatorDocFieldKey(out.length + 1, used);
            if (!key) key = `field_${out.length + 1}`;
            if (used[key]) key = this._nextEvaluatorDocFieldKey(out.length + 1, used);
            used[key] = true;
            const type = fieldTypes.some((t: any) => t.key === f.type) ? f.type : 'text';
            const row: any = {
                key,
                label: label || key,
                type,
                required: !!f.required,
            };
            if (type === 'select') {
                const options = Array.isArray(f.options)
                    ? f.options.map((v: any) => String(v || '').trim()).filter(Boolean)
                    : String(f.options || '').split(',').map((v: string) => v.trim()).filter(Boolean);
                row.options = options;
            } else if (f.options) {
                row.options = f.options;
            }
            out.push(row);
        }
        return out;
    }

    private _nextEvaluatorDocFieldKey(index: number, used: any = {}): string {
        let key = `field_${index}`;
        let n = index;
        while (used[key]) {
            n += 1;
            key = `field_${n}`;
        }
        return key;
    }

    private _cleanEvaluatorDocAttachmentsForSave(): any[] {
        const rows = Array.isArray(this.evaluatorDocForm.attachments) ? this.evaluatorDocForm.attachments : [];
        const out: any[] = [];
        for (const row of rows) {
            const name = String(row?.name || '').trim();
            const url = String(row?.url || '').trim();
            if (!name && !url) continue;
            if (!url) throw new Error('첨부파일 행에 파일을 선택하세요.');
            out.push({ name: name || row?.original_name || '첨부파일', url });
        }
        return out;
    }

    private _emptyEvaluatorDoc(mode: string): any {
        if (mode === 'request') {
            return {
                id: '',
                title: '',
                description: '',
                required: true,
                status: 'active',
                attachments: [],
                fields: this._defaultEvaluatorFields(),
            };
        }
        return {
            id: '',
            title: '',
            description: '',
            content: '',
            attachments: [],
            status: 'published',
        };
    }

    private _evaluatorDocListKey(mode: string): string {
        return mode === 'request' ? 'request' : 'provide';
    }

    public evaluatorProvidedDocs(): any[] {
        return this.evaluatorDocuments?.provide || [];
    }

    public evaluatorRequestedDocs(): any[] {
        return this.evaluatorDocuments?.request || [];
    }

    public async setEvaluatorDocMode(mode: string) {
        this.evaluatorDocMode = mode === 'submissions' ? 'submissions' : this._evaluatorDocListKey(mode);
        if (this.evaluatorDocMode === 'submissions') await this.loadEvaluatorDocSubmissions();
        await this.service.render();
    }

    public async loadEvaluatorDocSubmissions() {
        if (!this.program_id) return;
        const r = await wiz.call('list_evaluator_document_submissions', { program_id: this.program_id });
        if (r.code === 200) this.evaluatorDocSubmissions = r.data.rows || [];
        await this.service.render();
    }

    public openEvaluatorDocCreate(mode: string) {
        const key = this._evaluatorDocListKey(mode);
        this.editingEvaluatorDoc = null;
        this.evaluatorDocMode = key;
        this.evaluatorDocForm = this._emptyEvaluatorDoc(key);
        this.showEvaluatorDocEditor = true;
        this.service.render();
    }

    public openEvaluatorDocEdit(mode: string, doc: any) {
        const key = this._evaluatorDocListKey(mode);
        this.editingEvaluatorDoc = { mode: key, id: doc.id };
        this.evaluatorDocMode = key;
        this.evaluatorDocForm = {
            ...this._emptyEvaluatorDoc(key),
            ...JSON.parse(JSON.stringify(doc || {})),
        };
        this.evaluatorDocForm.fields = this._normalizeEvaluatorDocFields(this.evaluatorDocForm.fields, false);
        this.evaluatorDocForm.attachments = this._normalizeEvaluatorDocAttachments(this.evaluatorDocForm.attachments);
        this.showEvaluatorDocEditor = true;
        this.service.render();
    }

    public closeEvaluatorDocEditor() {
        this.showEvaluatorDocEditor = false;
        this.editingEvaluatorDoc = null;
        this.service.render();
    }

    public async uploadEvaluatorDocAttachment() {
        if (!Array.isArray(this.evaluatorDocForm.attachments)) this.evaluatorDocForm.attachments = [];
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        try {
            for (let i = 0; i < files.length; i++) {
                const fd = new FormData();
                fd.append('upload', files[i]);
                const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
                this.evaluatorDocForm.attachments.push({ name: files[i].name, url });
            }
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public addEvaluatorDocAttachmentRow() {
        if (!Array.isArray(this.evaluatorDocForm.attachments)) this.evaluatorDocForm.attachments = [];
        this.evaluatorDocForm.attachments.push({ name: '', url: '', original_name: '' });
        this.service.render();
    }

    public async uploadEvaluatorDocAttachmentAt(index: number) {
        if (!Array.isArray(this.evaluatorDocForm.attachments)) this.evaluatorDocForm.attachments = [];
        if (!this.evaluatorDocForm.attachments[index]) this.addEvaluatorDocAttachmentRow();
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        try {
            const fd = new FormData();
            fd.append('upload', files[0]);
            const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
            const row = this.evaluatorDocForm.attachments[index];
            row.url = url;
            row.original_name = files[0].name;
            if (!row.name) row.name = files[0].name;
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public removeEvaluatorDocAttachment(index: number) {
        if (!Array.isArray(this.evaluatorDocForm.attachments)) return;
        this.evaluatorDocForm.attachments.splice(index, 1);
        this.service.render();
    }

    public addEvaluatorDocFieldRow() {
        if (!Array.isArray(this.evaluatorDocForm.fields)) this.evaluatorDocForm.fields = [];
        const used: any = {};
        for (const f of this.evaluatorDocForm.fields) used[f.key] = true;
        this.evaluatorDocForm.fields.push({
            key: this._nextEvaluatorDocFieldKey(this.evaluatorDocForm.fields.length + 1, used),
            label: '',
            type: 'text',
            required: false,
            options: '',
        });
        this.service.render();
    }

    public addEvaluatorDocField() {
        if (!this.newEvaluatorDocField.key || !this.newEvaluatorDocField.label) {
            this.service.alert.show({ title: '입력 오류', message: '필드 key와 라벨을 입력하세요.', action: '확인' });
            return;
        }
        if (!Array.isArray(this.evaluatorDocForm.fields)) this.evaluatorDocForm.fields = [];
        const f: any = {
            key: this.newEvaluatorDocField.key,
            label: this.newEvaluatorDocField.label,
            type: this.newEvaluatorDocField.type || 'text',
            required: !!this.newEvaluatorDocField.required,
        };
        if (f.type === 'select' && this.newEvaluatorDocField.options) {
            f.options = this.newEvaluatorDocField.options.split(',').map((s: string) => s.trim()).filter(Boolean);
        }
        this.evaluatorDocForm.fields.push(f);
        this.newEvaluatorDocField = { key: '', label: '', type: 'text', required: false, options: '' };
    }

    public removeEvaluatorDocField(i: number) {
        this.evaluatorDocForm.fields.splice(i, 1);
        this.service.render();
    }

    public moveEvaluatorDocField(i: number, dir: number) {
        const j = i + dir;
        if (j < 0 || j >= this.evaluatorDocForm.fields.length) return;
        const tmp = this.evaluatorDocForm.fields[i];
        this.evaluatorDocForm.fields[i] = this.evaluatorDocForm.fields[j];
        this.evaluatorDocForm.fields[j] = tmp;
        this.service.render();
    }

    public evaluatorDocFieldOptionsText(f: any): string {
        if (!f) return '';
        return Array.isArray(f.options) ? f.options.join(', ') : String(f.options || '');
    }

    public setEvaluatorDocFieldOptionsText(f: any, value: string) {
        if (!f) return;
        f.options = value;
    }

    private async saveEvaluatorDocuments() {
        this.evaluatorDocuments = this._normalizeEvaluatorDocuments(this.evaluatorDocuments);
        const r = await wiz.call('update_evaluator_documents', {
            program_id: this.program_id,
            documents: JSON.stringify(this.evaluatorDocuments),
        });
        if (r.code !== 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '평가위원 요청자료 저장에 실패했습니다.', action: '확인' });
            return false;
        }
        if (!this.program.extra || typeof this.program.extra !== 'object') this.program.extra = {};
        this.program.extra.evaluator_documents = this.evaluatorDocuments;
        await this.service.render();
        return true;
    }

    public async submitEvaluatorDoc() {
        const mode = this._evaluatorDocListKey(this.editingEvaluatorDoc?.mode || this.evaluatorDocMode);
        if (!this.evaluatorDocForm.title) {
            this.service.alert.show({ title: '입력 오류', message: '자료명을 입력하세요.', action: '확인' });
            return;
        }
        this.evaluatorDocuments = this._normalizeEvaluatorDocuments(this.evaluatorDocuments);
        const list = this.evaluatorDocuments[mode] || [];
        const payload = {
            ...this.evaluatorDocForm,
            id: this.evaluatorDocForm.id || ('ED' + Date.now().toString(36)),
        };
        try {
            payload.attachments = this._cleanEvaluatorDocAttachmentsForSave();
        } catch (e: any) {
            this.service.alert.show({ title: '입력 오류', message: e?.message || '첨부파일을 확인하세요.', action: '확인' });
            return;
        }
        payload.fields = mode === 'request' ? this._normalizeEvaluatorDocFields(payload.fields, true) : [];
        const idx = list.findIndex((d: any) => d.id === payload.id);
        if (idx >= 0) list[idx] = payload;
        else list.push(payload);
        this.evaluatorDocuments[mode] = list;
        const ok = await this.saveEvaluatorDocuments();
        if (ok) this.showEvaluatorDocEditor = false;
    }

    public async removeEvaluatorDoc(mode: string, doc: any) {
        const ok = await this.service.alert.show({
            title: '자료 삭제',
            message: `"${doc.title}" 항목을 삭제하시겠습니까?`,
            action: '삭제',
            actionBtn: 'error',
            cancel: '취소',
        });
        if (!ok) return;
        const key = this._evaluatorDocListKey(mode);
        this.evaluatorDocuments[key] = (this.evaluatorDocuments[key] || []).filter((d: any) => d.id !== doc.id);
        await this.saveEvaluatorDocuments();
    }

    public evaluatorDocFieldTypeLabel(type: string): string {
        const found = this.evaluatorDocFieldTypes.find((t: any) => t.key === type);
        return found ? found.label : type;
    }

    public evaluatorDocStatusLabel(d: any): string {
        if ((d?.status || '') === 'draft') return '작성중';
        if ((d?.status || '') === 'active') return '요청중';
        return '공개';
    }

    public openEvaluatorDocSubmission(s: any) {
        this.selectedEvaluatorDocSubmission = s;
        this.service.render();
    }

    public closeEvaluatorDocSubmission() {
        this.selectedEvaluatorDocSubmission = null;
        this.service.render();
    }

    public evaluatorDocRequestForSubmission(s: any): any {
        const rid = s?.request_id || s?.extra?.request_id || '';
        if (!rid) return null;
        return this.evaluatorRequestedDocs().find((d: any) => d.id === rid) || null;
    }

    public evaluatorDocSubmissionValues(s: any): any[] {
        const data = (s?.form_data && typeof s.form_data === 'object') ? s.form_data : {};
        const req = this.evaluatorDocRequestForSubmission(s);
        const fields = Array.isArray(req?.fields) ? req.fields : [];
        const rows: any[] = [];
        const used: any = {};
        for (const f of fields) {
            const key = f?.key || '';
            if (!key) continue;
            used[key] = true;
            rows.push({ key, label: f.label || key, type: f.type || 'text', value: data[key] });
        }
        for (const key of Object.keys(data || {})) {
            if (used[key]) continue;
            rows.push({ key, label: key, type: 'text', value: data[key] });
        }
        return rows;
    }

    public evaluatorDocValueText(row: any): string {
        const v = row?.value;
        if (v === true) return '동의';
        if (v === false) return '미동의';
        if (v && typeof v === 'object') return v.name || v.file_name || v.url || JSON.stringify(v);
        if (Array.isArray(v)) return v.join(', ');
        return String(v === undefined || v === null ? '' : v);
    }

    public evaluatorDocValueUrl(row: any): string {
        const v = row?.value;
        if (!v) return '';
        if (typeof v === 'object') return v.url || v.file_url || '';
        const text = String(v);
        if (text.indexOf('/file/download/') === 0 || text.indexOf('http://') === 0 || text.indexOf('https://') === 0) return text;
        return '';
    }

    // ---- 평가 항목·배점 ----
    public async loadEvalCriteria() {
        const { code, data } = await wiz.call('get_eval_criteria', { program_id: this.program_id });
        if (code == 200) {
            this.evalCriteria = data.rows || [];
        }
        await this.service.render();
    }

    public openCriteriaEditor() {
        // 기래 항목 복사 (없으면 기본 한 행 추가)
        this.criteriaDraft = (this.evalCriteria || []).map((c: any) => ({ ...c }));
        if (this.criteriaDraft.length === 0) {
            this.criteriaDraft.push({ key: 'item_1', label: '', max_score: 10 });
        }
        this.showCriteriaEditor = true;
        this.service.render();
    }

    public addCriteriaRow() {
        const i = (this.criteriaDraft || []).length + 1;
        this.criteriaDraft.push({ key: 'item_' + i, label: '', max_score: 10 });
        this.service.render();
    }

    public removeCriteriaRow(idx: number) {
        this.criteriaDraft.splice(idx, 1);
        this.service.render();
    }

    public async saveCriteria() {
        // 유효성 체크
        const cleaned: any[] = [];
        for (let i = 0; i < this.criteriaDraft.length; i++) {
            const c = this.criteriaDraft[i];
            const label = (c.label || '').trim();
            if (!label) continue;
            let ms = Number(c.max_score);
            if (!ms || ms <= 0) ms = 10;
            cleaned.push({ key: c.key || ('item_' + (i + 1)), label, max_score: ms });
        }
        const { code, data } = await wiz.call('update_eval_criteria', {
            program_id: this.program_id,
            criteria: JSON.stringify(cleaned),
        });
        if (code != 200) {
            this.service.alert.show({ title: '저장 실패', message: data?.message || '오류', action: '확인' });
            return;
        }
        this.evalCriteria = data.rows || cleaned;
        this.showCriteriaEditor = false;
        await this.service.render();
    }

    public closeCriteriaEditor() {
        this.showCriteriaEditor = false;
        this.service.render();
    }

    public async submitEval() {
        if (!this.evalForm.evaluator_id) {
            this.service.alert.show({ title: '입력 오류', message: '평가위원을 선택하세요.', action: '확인' });
            return;
        }
        const payload: any = { ...this.evalForm };
        // 항목별 점수가 있으면 백엔드에서 score 를 산출 (criteria 기준 normalize 0~100)
        payload.scores = payload.scores || {};
        payload.score = Number(payload.score) || 0;
        const { code, data } = await wiz.call('upsert_evaluation', { data: JSON.stringify(payload) });
        if (code != 200) {
            this.service.alert.show({ title: '저장 실패', message: data?.message || '오류', action: '확인' });
            return;
        }
        this.evalForm = this._emptyEval();
        this.evalForm.program_id = this.program_id;
        this.evalForm.application_id = this.selectedApp.id;
        await this.loadEvaluations(this.selectedApp.id);
        await this.loadAllEvaluations();
        await this.loadApplications();
    }

    public async rejectEval(ev: any) {
        const ok = await this.service.alert.show({
            title: '평가 반려', message: '이 평가를 반려하고 평가위원이 다시 수정할 수 있게 하시겠습니까?',
            action: '반려', actionBtn: 'error', cancel: '취소'
        });
        if (!ok) return;
        const { code, data } = await wiz.call('reject_evaluation', { id: ev.id });
        if (code != 200) {
            this.service.alert.show({ title: '반려 실패', message: data?.message || '오류', action: '확인' });
            return;
        }
        await this.loadEvaluations(this.selectedApp.id);
        await this.loadAllEvaluations();
        await this.loadApplications();
    }

    public async deleteEval(ev: any) {
        const ok = await this.service.alert.show({
            title: '평가 요청 삭제', message: '이 평가 요청을 삭제하시겠습니까?',
            action: '삭제', actionBtn: 'error', cancel: '취소'
        });
        if (!ok) return;
        await wiz.call('delete_evaluation', { id: ev.id });
        await this.loadEvaluations(this.selectedApp.id);
        await this.loadAllEvaluations();
        await this.loadApplications();
    }

    public setEvaluationResultMode(mode: string) {
        this.evaluationResultMode = mode;
        this.refreshEvaluationResultRows();
        this.service.render();
    }

    private refreshEvaluationResultRows() {
        const appMap: any = {};
        const appRows = (this.evaluationApplications && this.evaluationApplications.length > 0)
            ? this.evaluationApplications
            : (this.applications || []);
        for (const app of appRows || []) {
            appMap[app.id] = app;
        }
        const rows = (this.allEvaluations || []).map((ev: any) => {
            const app = appMap[ev.application_id] || {};
            return {
                ...ev,
                company_name: app.company_name || ev.application_id || '-',
                company_status: app.status || '',
                app_rank: app.rank || '',
                app_score_total: app.score_total || 0,
            };
        });
        rows.sort((a: any, b: any) => {
            const firstA = this.evaluationResultMode === 'evaluator' ? (a.evaluator_name || '') : (a.company_name || '');
            const firstB = this.evaluationResultMode === 'evaluator' ? (b.evaluator_name || '') : (b.company_name || '');
            if (firstA !== firstB) return firstA.localeCompare(firstB);
            const secondA = this.evaluationResultMode === 'evaluator' ? (a.company_name || '') : (a.evaluator_name || '');
            const secondB = this.evaluationResultMode === 'evaluator' ? (b.company_name || '') : (b.evaluator_name || '');
            if (secondA !== secondB) return secondA.localeCompare(secondB);
            return this.evalStageLabel(a.stage).localeCompare(this.evalStageLabel(b.stage));
        });
        this.evaluationResultRowsCache = rows;
        this.submittedEvaluationResultCountValue = (this.allEvaluations || []).filter((ev: any) => ev.status === 'submitted').length;
    }

    public evaluationResultRows(): any[] {
        return this.evaluationResultRowsCache || [];
    }

    public evaluationResultRowCount(): number {
        return (this.evaluationResultRowsCache || []).length;
    }

    public submittedEvaluationResultCount(): number {
        return this.submittedEvaluationResultCountValue || 0;
    }

    private _csvValue(value: any): string {
        const text = String(value === undefined || value === null ? '' : value).replace(/\r?\n/g, ' ');
        if (/[",\n]/.test(text)) return '"' + text.replace(/"/g, '""') + '"';
        return text;
    }

    public downloadEvaluationResults() {
        const rows = this.evaluationResultRows();
        const criteria = this.evalCriteria || [];
        const leading = this.evaluationResultMode === 'evaluator'
            ? ['평가위원', '기업']
            : ['기업', '평가위원'];
        const headers = [
            ...leading,
            '단계',
            '상태',
            ...criteria.map((c: any) => `${c.label}(${c.max_score})`),
            '종합점수',
            '기업 종합점수',
            '순위',
            '의견',
        ];
        const lines = [headers.map((h: any) => this._csvValue(h)).join(',')];
        for (const row of rows) {
            const first = this.evaluationResultMode === 'evaluator' ? row.evaluator_name : row.company_name;
            const second = this.evaluationResultMode === 'evaluator' ? row.company_name : row.evaluator_name;
            const values = [
                first || '-',
                second || '-',
                this.evalStageLabel(row.stage),
                this.evalStatusInfo(row.status).label,
                ...criteria.map((c: any) => this.evaluationItemScore(row, c)),
                this.evaluationScore(row),
                row.app_score_total || 0,
                row.app_rank || '',
                row.comment || '',
            ];
            lines.push(values.map((v: any) => this._csvValue(v)).join(','));
        }
        const blob = new Blob(['\ufeff' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `evaluation-results-${this.program_id}-${this.evaluationResultMode}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    // ======================== OPERATIONS TAB ========================

    private _emptyMilestone() {
        return {
            program_id: '', title: '', type: 'event',
            start_date: '', end_date: '', location: '',
            description: '', status: 'planned',
            extra: {
                module_ids: [], types: ['event'],
                start_time: '', end_time: '',
                time_tbd: false, location_tbd: false,
                target_mode: 'all', target_app_ids: [],
            }
        };
    }

    public milestoneTimeLabel(m: any): string {
        const ex = m && m.extra ? m.extra : {};
        if (ex.time_tbd) return '시간 추후 안내 예정';
        const s = ex.start_time || '';
        const e = ex.end_time || '';
        if (s && e) return `${s} ~ ${e}`;
        if (s) return s;
        return '';
    }

    public milestoneLocationLabel(m: any): string {
        const ex = m && m.extra ? m.extra : {};
        if (ex.location_tbd) return '장소 추후 안내 예정';
        return m && m.location ? m.location : '';
    }

    public moduleTitleById(mid: string): string {
        const m = (this.modules || []).find((x: any) => x.id === mid);
        if (!m) return mid;
        const t = this.moduleTypes.find((x: any) => x.key === m.module_type);
        return (t ? t.label : m.module_type) + (m.title && m.title !== (t ? t.label : '') ? ` - ${m.title}` : '');
    }

    public toggleMilestoneModule(mid: string) {
        if (!this.newMilestone.extra) this.newMilestone.extra = {};
        if (!Array.isArray(this.newMilestone.extra.module_ids)) this.newMilestone.extra.module_ids = [];
        const arr = this.newMilestone.extra.module_ids;
        const i = arr.indexOf(mid);
        if (i >= 0) arr.splice(i, 1); else arr.push(mid);
        this.service.render();
    }

    public hasMilestoneModule(mid: string): boolean {
        const arr = this.newMilestone?.extra?.module_ids || [];
        return arr.includes(mid);
    }

    public milestoneModuleIds(m: any): string[] {
        return (m && m.extra && Array.isArray(m.extra.module_ids)) ? m.extra.module_ids : [];
    }

    // 운영(milestone) 다중 유형 (FN-20260508-0034)
    public milestoneTypeOptions: any[] = [
        { key: 'event',         label: '행사' },
        { key: 'recruitment',   label: '모집공고' },
        { key: 'selection',     label: '선발' },
        { key: 'kickoff',       label: '킥오프' },
        { key: 'diagnosis',     label: '진단' },
        { key: 'education',     label: '교육' },
        { key: 'workshop',      label: '워크숍' },
        { key: 'mentoring',     label: '멘토링' },
        { key: 'networking',    label: '네트워킹' },
        { key: 'site_visit',    label: '현장방문' },
        { key: 'ir_pitching',   label: 'IR 피칭' },
        { key: 'demoday',       label: '데모데이' },
        { key: 'funding_match', label: '투자매칭' },
        { key: 'expense_mgmt',  label: '예산집행' },
        { key: 'survey',        label: '만족도조사' },
        { key: 'company_mgmt',  label: '기업관리' },
        { key: 'reporting',     label: '보고' },
        { key: 'follow_up',     label: '사후관리' },
        { key: 'midcheck',      label: '중간점검' },
        { key: 'final',         label: '최종발표' },
        { key: 'settlement',    label: '정산' },
    ];

    public milestoneTypes(m: any): string[] {
        if (!m) return [];
        const arr = (m.extra && Array.isArray(m.extra.types)) ? m.extra.types.slice() : [];
        if (m.type && arr.indexOf(m.type) === -1) arr.unshift(m.type);
        return arr;
    }

    public hasMilestoneType(key: string): boolean {
        const arr = (this.newMilestone?.extra?.types) || [];
        if (Array.isArray(arr) && arr.includes(key)) return true;
        return this.newMilestone?.type === key;
    }

    public toggleMilestoneType(key: string) {
        if (!this.newMilestone.extra) this.newMilestone.extra = {};
        if (!Array.isArray(this.newMilestone.extra.types)) {
            this.newMilestone.extra.types = this.newMilestone.type ? [this.newMilestone.type] : [];
        }
        const arr: string[] = this.newMilestone.extra.types;
        const i = arr.indexOf(key);
        if (i >= 0) arr.splice(i, 1);
        else arr.push(key);
        // primary type = 첫 번째 선택값
        this.newMilestone.type = arr[0] || 'event';
        this.service.render();
    }

    public async loadMilestones() {
        const { code, data } = await wiz.call('list_milestones', { program_id: this.program_id });
        if (code == 200) {
            this.milestones = data.rows || [];
        }
        // 모듈 정보도 로드 (milestone에 module_ids 연결 표시용)
        if (!this.modules || this.modules.length === 0) {
            try {
                const r2 = await wiz.call('list_modules', { program_id: this.program_id });
                if (r2.code === 200) this.modules = r2.data.rows || [];
            } catch { }
        }
        await this.service.render();
    }

    public openMilestoneCreate() {
        this.newMilestone = this._emptyMilestone();
        this.newMilestone.program_id = this.program_id;
        this.editingMilestone = null;
        this.showMilestoneCreate = true;
        // 모듈 로드
        if (!this.modules || this.modules.length === 0) {
            wiz.call('list_modules', { program_id: this.program_id }).then((r: any) => {
                if (r.code === 200) { this.modules = r.data.rows || []; this.service.render(); }
            });
        }
        // 대상 기업(선발된 신청 기업) 로드
        this._loadTargetCompanies();
        this.service.render();
    }

    public openMilestoneEdit(m: any) {
        this.newMilestone = JSON.parse(JSON.stringify(m));
        if (!this.newMilestone.extra) this.newMilestone.extra = { module_ids: [] };
        if (!Array.isArray(this.newMilestone.extra.module_ids)) this.newMilestone.extra.module_ids = [];
        if (!Array.isArray(this.newMilestone.extra.types)) {
            this.newMilestone.extra.types = this.newMilestone.type ? [this.newMilestone.type] : [];
        }
        if (!this.newMilestone.extra.target_mode) this.newMilestone.extra.target_mode = 'all';
        if (!Array.isArray(this.newMilestone.extra.target_app_ids)) this.newMilestone.extra.target_app_ids = [];
        this.editingMilestone = m;
        this.showMilestoneCreate = true;
        if (!this.modules || this.modules.length === 0) {
            wiz.call('list_modules', { program_id: this.program_id }).then((r: any) => {
                if (r.code === 200) { this.modules = r.data.rows || []; this.service.render(); }
            });
        }
        this._loadTargetCompanies();
        this.service.render();
    }

    // 운영에 대상 기업 체크리스트를 위한 선발 기업 목록
    public targetCompanies: any[] = [];
    private async _loadTargetCompanies() {
        if (this.targetCompanies && this.targetCompanies.length > 0) return;
        try {
            const r = await wiz.call('list_applications', { program_id: this.program_id, status: 'selected' });
            if (r.code === 200) this.targetCompanies = r.data.rows || [];
        } catch { }
        await this.service.render();
    }
    public hasTargetApp(appId: string): boolean {
        const arr = this.newMilestone?.extra?.target_app_ids || [];
        return arr.indexOf(appId) !== -1;
    }
    public toggleTargetApp(appId: string) {
        if (!this.newMilestone.extra) this.newMilestone.extra = {};
        if (!Array.isArray(this.newMilestone.extra.target_app_ids)) this.newMilestone.extra.target_app_ids = [];
        const arr = this.newMilestone.extra.target_app_ids;
        const i = arr.indexOf(appId);
        if (i >= 0) arr.splice(i, 1); else arr.push(appId);
        this.service.render();
    }
    public toggleAllTargetApps() {
        if (!this.newMilestone.extra) this.newMilestone.extra = {};
        const all = (this.targetCompanies || []).map((a: any) => a.id);
        const cur = this.newMilestone.extra.target_app_ids || [];
        if (cur.length === all.length) this.newMilestone.extra.target_app_ids = [];
        else this.newMilestone.extra.target_app_ids = all.slice();
        this.service.render();
    }
    public milestoneTargetLabel(m: any): string {
        const ex = m && m.extra ? m.extra : {};
        const mode = ex.target_mode || 'all';
        const ids = Array.isArray(ex.target_app_ids) ? ex.target_app_ids : [];
        if (mode === 'all') return '참여 기업 전체';
        if (ids.length === 0) return '대상 기업 미지정';
        return `선택 ${ids.length}개 기업`;
    }
    public milestoneTargetCompanies(m: any): any[] {
        const ex = m && m.extra ? m.extra : {};
        const mode = ex.target_mode || 'all';
        const all = this.targetCompanies || [];
        if (mode === 'all') return all;
        const ids = Array.isArray(ex.target_app_ids) ? ex.target_app_ids : [];
        return all.filter((a: any) => ids.indexOf(a.id) !== -1);
    }

    public closeMilestoneModal() {
        this.showMilestoneCreate = false;
        this.editingMilestone = null;
        this.service.render();
    }

    public async submitMilestone() {
        if (!this.newMilestone.title) {
            this.service.alert.show({ title: '입력 오류', message: '일정명을 입력하세요.', action: '확인' });
            return;
        }
        const payload: any = { ...this.newMilestone };
        ['start_date','end_date'].forEach(k => { if (!payload[k]) payload[k] = null; });

        let res;
        if (this.editingMilestone) {
            res = await wiz.call('update_milestone', { id: this.editingMilestone.id, data: JSON.stringify(payload) });
        } else {
            res = await wiz.call('create_milestone', { data: JSON.stringify(payload) });
        }
        if (res.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: res.data?.message || '오류', action: '확인' });
            return;
        }
        this.showMilestoneCreate = false;
        this.editingMilestone = null;
        await this.loadMilestones();
        // 모집공고 유형 자동 동기화 결과 반영
        if (this.selectedMilestone && this.isRecruitmentMilestone(this.selectedMilestone)) {
            await this.loadRecruitmentAnnouncement(true);
        }
    }

    public async deleteMilestone(m: any) {
        const ok = await this.service.alert.show({
            title: '일정 삭제', message: `"${m.title}" 일정을 삭제하시겠습니까?`,
            action: '삭제', actionBtn: 'error', cancel: '취소'
        });
        if (!ok) return;
        await wiz.call('delete_milestone', { id: m.id });
        await this.loadMilestones();
    }

    public goBack() {
        this.service.href('/admin/support/programs');
    }

    public categoryOptions: string[] = [
        '예비창업', '초기창업', '도약기', '재창업', '여성창업', '청년창업', '시니어창업',
        '딥테크', 'AI/SW', '바이오/헬스', '소재·부품·장비', 'ESG/그린', '콘텐츠/문화',
        '제조', '서비스/플랫폼', '글로벌', '지역특화'
    ];

    public onCategoryChange(item: any) {
        if (item._categorySelect === '__custom__') {
            item.category = '';
        } else {
            item.category = item._categorySelect || '';
        }
    }

    // ======================== INVITE ========================

    public async sendInvite(app: any) {
        if (!app.ceo_email) {
            this.service.alert.show({ title: '이메일 누락', message: '담당자 이메일을 먼저 입력해 주세요.', action: '확인' });
            return;
        }
        const ok = await this.service.alert.show({
            title: '신청 초대 메일 발송',
            message: `${app.company_name} (${app.ceo_email}) 으로\n신청서 작성 링크를 발송하시겠습니까?`,
            action: '발송', cancel: '취소'
        });
        if (!ok) return;
        const { code, data } = await wiz.call('send_invite', { id: app.id });
        if (code != 200) {
            this.service.alert.show({ title: '발송 실패', message: data?.message || '오류', action: '확인' });
            return;
        }
        this.service.alert.show({ title: '발송 완료', message: '초대 메일이 발송되었습니다.', action: '확인' });
        await this.loadApplications();
    }

    public inviteStatusInfo(s: string) {
        const map: any = {
            none: { label: '미발송', cls: 'bg-zinc-100 text-zinc-600' },
            sent: { label: '발송됨', cls: 'bg-blue-50 text-blue-700' },
            opened: { label: '열람', cls: 'bg-amber-50 text-amber-700' },
            submitted: { label: '제출완료', cls: 'bg-emerald-50 text-emerald-700' },
        };
        return map[s] || map.none;
    }

    // ======================== BOARD ========================

    public async loadPosts() {
        const { code, data } = await wiz.call('list_posts', {
            program_id: this.program_id, type: this.postTypeFilter, text: this.postSearch
        });
        if (code == 200) this.posts = data.rows || [];
        await this.service.render();
    }

    public openPostCreate() {
        this.postForm = { program_id: this.program_id, title: '', content: '', type: 'notice', pinned: false };
        this.editingPost = null;
        this.showPostEditor = true;
        this.service.render();
    }

    public openPostEdit(p: any) {
        this.postForm = { ...p, program_id: this.program_id };
        this.editingPost = p;
        this.showPostEditor = true;
        this.service.render();
    }

    public closePostEditor() {
        this.showPostEditor = false;
        this.editingPost = null;
        this.service.render();
    }

    public async submitPost() {
        if (!this.postForm.title) {
            this.service.alert.show({ title: '입력 오류', message: '제목을 입력하세요.', action: '확인' });
            return;
        }
        const payload: any = { ...this.postForm };
        payload.program_id = this.program_id;
        payload.pinned = !!payload.pinned;
        let res;
        if (this.editingPost) {
            res = await wiz.call('update_post', { id: this.editingPost.id, data: JSON.stringify(payload) });
        } else {
            res = await wiz.call('create_post', { data: JSON.stringify(payload) });
        }
        if (res.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: res.data?.message || '오류', action: '확인' });
            return;
        }
        this.showPostEditor = false;
        this.editingPost = null;
        await this.loadPosts();
    }

    public async openPost(p: any) {
        const { code, data } = await wiz.call('get_post', { id: p.id });
        if (code != 200) return;
        this.selectedPost = data.data;
        this.newComment = '';
        await this.service.render();
    }

    public closePost() {
        this.selectedPost = null;
        this.service.render();
    }

    public async deletePost(p: any) {
        const ok = await this.service.alert.show({
            title: '삭제', message: `"${p.title}" 게시글을 삭제하시겠습니까?`,
            action: '삭제', actionBtn: 'error', cancel: '취소'
        });
        if (!ok) return;
        await wiz.call('delete_post', { id: p.id });
        this.selectedPost = null;
        await this.loadPosts();
    }

    public async submitComment() {
        if (!this.selectedPost || !this.newComment.trim()) return;
        const { code } = await wiz.call('create_comment', {
            post_id: this.selectedPost.id, content: this.newComment.trim()
        });
        if (code != 200) return;
        this.newComment = '';
        const { data } = await wiz.call('get_post', { id: this.selectedPost.id });
        if (data) this.selectedPost = data.data;
        await this.service.render();
    }

    public async deleteComment(c: any) {
        const ok = await this.service.alert.show({
            title: '댓글 삭제', message: '댓글을 삭제하시겠습니까?', action: '삭제', actionBtn: 'error', cancel: '취소'
        });
        if (!ok) return;
        await wiz.call('delete_comment', { id: c.id });
        const { data } = await wiz.call('get_post', { id: this.selectedPost.id });
        if (data) this.selectedPost = data.data;
        await this.service.render();
    }

    public postTypeLabel(t: string): string {
        return ({ notice: '공지', free: '자유', qna: 'Q&A', faq: 'FAQ', resource: '자료실', submit: '제출요청' } as any)[t] || t;
    }

    // ======================== CALENDAR ========================

    public async loadCalendar() {
        // 마일스톤이 곧 캘린더 데이터
        await this.loadMilestones();
        this.buildCalendarCells();
    }

    public prevMonth() {
        if (this.calendarMonth === 1) { this.calendarMonth = 12; this.calendarYear--; }
        else this.calendarMonth--;
        this.buildCalendarCells();
        this.service.render();
    }

    public nextMonth() {
        if (this.calendarMonth === 12) { this.calendarMonth = 1; this.calendarYear++; }
        else this.calendarMonth++;
        this.buildCalendarCells();
        this.service.render();
    }

    public goToday() {
        const now = new Date();
        this.calendarYear = now.getFullYear();
        this.calendarMonth = now.getMonth() + 1;
        this.buildCalendarCells();
        this.service.render();
    }

    private buildCalendarCells() {
        const y = this.calendarYear, m = this.calendarMonth;
        const first = new Date(y, m - 1, 1);
        const startDay = first.getDay(); // 0=Sun
        const daysInMonth = new Date(y, m, 0).getDate();
        const cells: any[] = [];
        // 이전 달 빈 칸
        for (let i = 0; i < startDay; i++) cells.push({ blank: true });
        for (let d = 1; d <= daysInMonth; d++) {
            const ds = `${y}-${String(m).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
            cells.push({
                day: d,
                date: ds,
                isToday: ds === this.todayString(),
                events: this.eventsOnDate(ds),
            });
        }
        // 6주 격자 보장
        while (cells.length % 7 !== 0) cells.push({ blank: true });
        this.calendarCells = cells;
    }

    private todayString(): string {
        const t = new Date();
        return `${t.getFullYear()}-${String(t.getMonth()+1).padStart(2,'0')}-${String(t.getDate()).padStart(2,'0')}`;
    }

    private eventsOnDate(ds: string): any[] {
        return (this.milestones || []).filter((m: any) => {
            const s = (m.start_date || '').slice(0, 10);
            const e = (m.end_date || s || '').slice(0, 10);
            if (!s) return false;
            return ds >= s && ds <= e;
        });
    }

    public eventColorClass(type: string): string {
        const map: any = {
            event: 'bg-blue-500', mentoring: 'bg-violet-500', education: 'bg-amber-500',
            midcheck: 'bg-orange-500', final: 'bg-emerald-600', settlement: 'bg-zinc-600',
        };
        return map[type] || 'bg-zinc-500';
    }

    // ======================== MODULES (used by operations) ========================
    public modules: any[] = [];
    public moduleTypes = [
        { key: 'recruitment',   label: '모집공고',   icon: '📢', desc: '공고 등록 · 접수',                       multi: false },
        { key: 'selection',     label: '선발',       icon: '🎯', desc: '평가 · 선발 결과',                        multi: false },
        { key: 'kickoff',       label: '킥오프',     icon: '🚩', desc: '오리엔테이션 · 시작 행사',                multi: false },
        { key: 'diagnosis',     label: '진단',       icon: '📊', desc: '기업 진단 · 진단표',                      multi: false },
        { key: 'education',     label: '교육',       icon: '🎓', desc: '교육 과정 · 출석 (다수 회차 가능)',       multi: true  },
        { key: 'workshop',      label: '워크숍',     icon: '🛠️', desc: '실무 워크숍 · 실습 (다수 회차)',          multi: true  },
        { key: 'mentoring',     label: '멘토링',     icon: '🤝', desc: '멘토 매칭 · 회차 (다수 추가 가능)',       multi: true  },
        { key: 'networking',    label: '네트워킹',   icon: '🌐', desc: '교류회 · 파트너십 (다수)',                multi: true  },
        { key: 'site_visit',    label: '현장방문',   icon: '🚗', desc: '현장 방문 · 기업 탐방',                   multi: true  },
        { key: 'ir_pitching',   label: 'IR 피칭',    icon: '🎤', desc: 'IR 발표 · 피드백 (다수)',                 multi: true  },
        { key: 'demoday',       label: '데모데이',   icon: '🚀', desc: '최종 데모데이 · 외부 공개',               multi: false },
        { key: 'funding_match', label: '투자매칭',   icon: '💰', desc: '투자자 매칭 · 미팅 주선',                multi: false },
        { key: 'expense_mgmt',  label: '예산집행',   icon: '🧾', desc: '비용 집행 · 정산 관리',                  multi: false },
        { key: 'survey',        label: '만족도조사', icon: '📝', desc: '설문 · 피드백 수집 (다수)',              multi: true  },
        { key: 'company_mgmt',  label: '기업관리',   icon: '🏢', desc: '참여기업 관리 · 담당자 배정',             multi: false },
        { key: 'follow_up',     label: '사후관리',   icon: '🔁', desc: '졸업 후 트래킹 · 성과 모니터링',          multi: false },
        { key: 'reporting',     label: '보고',       icon: '📑', desc: '보고서 · 성과 제출',                     multi: false },
    ];

    public async loadModules() {
        const { code, data } = await wiz.call('list_modules', { program_id: this.program_id });
        if (code == 200) {
            this.modules = data.rows || [];
        }
        await this.service.render();
    }

    public moduleTypeLabel(type: string): string {
        const t = this.moduleTypes.find(x => x.key === type);
        return t ? `${t.icon} ${t.label}` : type;
    }

    public goModuleManage(mod: any) {
        // FN-20260508-0008/0009/0010: /admin/:cat/:main/:sub/:id/:menu 패턴에 맞춰 5단계로
        this.service.href(`/admin/support/modules/${mod.module_type}/${mod.id}/${this.program_id}`);
    }

    public goModuleManageById(mid: string) {
        const mod = (this.modules || []).find((x: any) => x.id === mid);
        if (mod) this.goModuleManage(mod);
    }

    // ========== KPI (FN-0020) ==========
    public kpis: any[] = [];
    public showKpiEditor: boolean = false;
    public kpiForm: any = this._emptyKpi();
    public editingKpi: any = null;
    public kpiMetrics: any[] = [
        { key: '', label: '(수동 입력)' },
        { key: 'revenue', label: '매출액' },
        { key: 'investment', label: '투자유치액' },
        { key: 'employment', label: '신규 고용' },
        { key: 'patent', label: '특허/IP' },
        { key: 'export', label: '수출액' },
    ];

    private _emptyKpi() {
        return { name: '', metric: '', unit: '', target_value: 0, current_value: 0, weight: 1.0, order_no: 0, description: '', status: 'active' };
    }
    public async loadKpis() {
        const res = await wiz.call('list_kpis', { program_id: this.program_id });
        this.kpis = res.data?.rows || [];
        await this.service.render();
    }
    public openKpiCreate() { this.editingKpi = null; this.kpiForm = this._emptyKpi(); this.showKpiEditor = true; }
    public openKpiEdit(k: any) { this.editingKpi = k; this.kpiForm = { ...k }; this.showKpiEditor = true; }
    public closeKpiEditor() { this.showKpiEditor = false; this.service.render(); }
    public async submitKpi() {
        if (!this.kpiForm.name) { this.service.alert.show({ title: '오류', message: 'KPI명을 입력하세요' }); return; }
        const payload: any = { ...this.kpiForm };
        const res = await wiz.call('upsert_kpi', { program_id: this.program_id, id: this.editingKpi?.id || '', data: JSON.stringify(payload) });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '저장 실패' }); return; }
        this.showKpiEditor = false;
        await this.loadKpis();
    }
    public async deleteKpi(k: any) {
        const ok = await this.service.alert.show({
            title: 'KPI 삭제', message: `"${k.name}" KPI를 삭제하시겠습니까?`,
            action: '삭제', actionBtn: 'error', cancel: '취소'
        });
        if (!ok) return;
        const res = await wiz.call('delete_kpi', { id: k.id });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '삭제 실패' }); return; }
        await this.loadKpis();
    }
    public async recalcKpi() {
        const res = await wiz.call('recalc_kpi', { program_id: this.program_id });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '재계산 실패' }); return; }
        this.kpis = res.data?.rows || [];
        await this.service.render();
    }

    // ========== Documents (FN-0023) ==========
    public documents: any[] = [];
    public docTypeFilter: string = '';
    public docTypes: any[] = [
        { key: '', label: '전체' },
        { key: 'plan', label: '기획안' },
        { key: 'promotion', label: '홍보안' },
        { key: 'notice', label: '공지' },
        { key: 'contact_log', label: '연락기록' },
        { key: 'report', label: '보고서' },
        { key: 'other', label: '기타' },
    ];
    public docStatusMap: any = {
        draft: { label: '작성중', cls: 'bg-zinc-100 text-zinc-600' },
        submitted: { label: '결재중', cls: 'bg-amber-100 text-amber-700' },
        approved: { label: '결재완료', cls: 'bg-emerald-100 text-emerald-700' },
        rejected: { label: '반려', cls: 'bg-red-100 text-red-700' },
        published: { label: '게시', cls: 'bg-blue-100 text-blue-700' },
    };
    public showDocEditor: boolean = false;
    public docForm: any = this._emptyDoc();
    public editingDoc: any = null;
    public docFormTemplate: any = null;

    private _emptyDoc() {
        return { program_id: this.program_id, doc_type: 'plan', title: '', content: '',
                 form_data: {}, attachments: [], target_audience: 'internal', status: 'draft' };
    }
    public docTypeLabel(t: string) { const x = this.docTypes.find(d => d.key === t); return x ? x.label : t; }
    public docStatusInfo(s: string) { return this.docStatusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' }; }

    public async loadDocuments() {
        const res = await wiz.call('list_documents', { program_id: this.program_id, doc_type: this.docTypeFilter });
        this.documents = res.data?.rows || [];
        await this.service.render();
    }
    public async filterDocs(t: string) { this.docTypeFilter = t; await this.loadDocuments(); }
    public async openDocCreate(docType: string = 'plan') {
        this.editingDoc = null;
        this.docForm = this._emptyDoc();
        this.docForm.doc_type = docType;
        await this._loadFormTemplate(docType);
        this.showDocEditor = true;
        await this.service.render();
    }
    public async openDocEdit(d: any) {
        this.editingDoc = d;
        this.docForm = { ...d };
        if (typeof this.docForm.form_data === 'string') { try { this.docForm.form_data = JSON.parse(this.docForm.form_data); } catch { this.docForm.form_data = {}; } }
        await this._loadFormTemplate(d.doc_type);
        this.showDocEditor = true;
        await this.service.render();
    }
    private async _loadFormTemplate(docType: string) {
        const res = await wiz.call('resolve_form', { form_type: docType, program_id: this.program_id });
        this.docFormTemplate = res.data?.template || null;
    }
    public async onDocTypeChange() {
        await this._loadFormTemplate(this.docForm.doc_type);
        await this.service.render();
    }
    public closeDocEditor() { this.showDocEditor = false; this.service.render(); }
    public async submitDoc() {
        if (!this.docForm.title) { this.service.alert.show({ title: '오류', message: '제목을 입력하세요' }); return; }
        const payload: any = { ...this.docForm };
        const res = await wiz.call('upsert_document', { id: this.editingDoc?.id || '', data: JSON.stringify(payload) });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '저장 실패' }); return; }
        this.showDocEditor = false;
        if (this.selectedMilestone) await this.loadPhaseDocuments();
        else await this.loadDocuments();
    }
    public async deleteDoc(d: any) {
        const ok = await this.service.alert.show({
            title: '문서 삭제', message: `"${d.title}" 문서를 삭제하시겠습니까?`,
            action: '삭제', actionBtn: 'error', cancel: '취소'
        });
        if (!ok) return;
        const res = await wiz.call('delete_document', { id: d.id });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '삭제 실패' }); return; }
        if (this.selectedMilestone) await this.loadPhaseDocuments();
        else await this.loadDocuments();
    }
    public async submitDocApproval(d: any) {
        const tplId = prompt('결재 양식 ID (없으면 빈칸)', '') || '';
        const res = await wiz.call('submit_document_approval', { id: d.id, template_id: tplId, line_users: '[]', comment: '' });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '결재 상신 실패' }); return; }
        this.service.alert.show({ title: '완료', message: '결재 상신 완료' });
        if (this.selectedMilestone) await this.loadPhaseDocuments();
        else await this.loadDocuments();
    }
    public async publishDoc(d: any) {
        const ok = await this.service.alert.show({
            title: '문서 게시', message: '이 문서를 게시 상태로 변경하시겠습니까?',
            action: '게시', cancel: '취소'
        });
        if (!ok) return;
        const res = await wiz.call('publish_document', { id: d.id });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '게시 실패' }); return; }
        if (this.selectedMilestone) await this.loadPhaseDocuments();
        else await this.loadDocuments();
    }

    // ========== Budget / Expense (FN-20260508-0035) ==========
    public budgets: any[] = [];
    public budgetSummary: any = { total_planned: 0, total_spent: 0, remaining: 0, exec_rate: 0, budget_count: 0, expense_count: 0, unallocated_spent: 0, by_category: [] };
    public expenses: any[] = [];
    public expenseTotal: number = 0;
    public expenseFilterBudget: string = '';
    public expenseFilterStatus: string = '';
    public expenseSearch: string = '';
    public expensePage: number = 1;

    public showBudgetEditor: boolean = false;
    public editingBudget: any = null;
    public budgetForm: any = this._emptyBudget();

    public showExpenseEditor: boolean = false;
    public editingExpense: any = null;
    public expenseForm: any = this._emptyExpense();

    public budgetCategories: string[] = ['인건비', '운영비', '홍보비', '외주비', '재료비', '여비교통비', '행사비', '기타'];
    public expenseStatusMap: any = {
        pending: { label: '검토중', cls: 'bg-amber-50 text-amber-700' },
        approved: { label: '승인', cls: 'bg-emerald-50 text-emerald-700' },
        rejected: { label: '반려', cls: 'bg-red-50 text-red-700' },
    };
    public expenseMethodMap: any = {
        card: '카드', cash: '현금', bank: '계좌이체', etc: '기타',
    };
    public approvalStatusMap: any = {
        draft: { label: '기안', cls: 'bg-zinc-100 text-zinc-700' },
        pending: { label: '결재중', cls: 'bg-amber-50 text-amber-700' },
        approved: { label: '승인', cls: 'bg-emerald-50 text-emerald-700' },
        rejected: { label: '반려', cls: 'bg-red-50 text-red-700' },
        withdrawn: { label: '회수', cls: 'bg-zinc-100 text-zinc-500' },
        revision_requested: { label: '재기안', cls: 'bg-blue-50 text-blue-700' },
    };

    private _emptyBudget() {
        return { name: '', category: '운영비', planned_amount: 0, description: '', order_no: 0 };
    }
    private _emptyExpense() {
        const today = new Date().toISOString().slice(0, 10);
        return { title: '', amount: 0, budget_id: '', spent_at: today, vendor: '', method: 'card', status: 'approved', receipt: '', note: '' };
    }

    public async loadBudgets() {
        const res = await wiz.call('list_budgets', { program_id: this.program_id });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '예산을 불러올 수 없습니다.' }); return; }
        this.budgets = res.data?.rows || [];
        this.budgetSummary = res.data?.summary || this.budgetSummary;
        await this.loadExpenses();
    }

    public async loadExpenses() {
        const res = await wiz.call('list_expenses', {
            program_id: this.program_id,
            budget_id: this.expenseFilterBudget,
            status: this.expenseFilterStatus,
            text: this.expenseSearch,
            page: this.expensePage,
            dump: 50,
        });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '지출 내역을 불러올 수 없습니다.' }); return; }
        this.expenses = res.data?.rows || [];
        this.expenseTotal = res.data?.total || 0;
        await this.service.render();
    }

    public openBudgetCreate() {
        this.editingBudget = null;
        this.budgetForm = this._emptyBudget();
        this.showBudgetEditor = true;
        this.service.render();
    }
    public openBudgetEdit(b: any) {
        this.editingBudget = b;
        this.budgetForm = { ...b };
        this.showBudgetEditor = true;
        this.service.render();
    }
    public closeBudgetEditor() { this.showBudgetEditor = false; this.service.render(); }
    public async submitBudget() {
        if (!this.budgetForm.name) { this.service.alert.show({ title: '오류', message: '항목명을 입력하세요' }); return; }
        const payload: any = { ...this.budgetForm };
        payload.planned_amount = Number(payload.planned_amount) || 0;
        payload.order_no = Number(payload.order_no) || 0;
        const res = await wiz.call('upsert_budget', { program_id: this.program_id, id: this.editingBudget?.id || '', data: JSON.stringify(payload) });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '저장 실패' }); return; }
        this.showBudgetEditor = false;
        await this.loadBudgets();
    }
    public async deleteBudget(b: any) {
        const ok = await this.service.alert.show({
            title: '예산 항목 삭제', message: `"${b.name}" 예산 항목을 삭제하시겠습니까?\n연결된 지출은 미분류로 변경됩니다.`,
            action: '삭제', actionBtn: 'error', cancel: '취소'
        });
        if (!ok) return;
        const res = await wiz.call('delete_budget', { id: b.id });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '삭제 실패' }); return; }
        await this.loadBudgets();
    }

    public openExpenseCreate(budget_id: string = '') {
        this.editingExpense = null;
        this.expenseForm = this._emptyExpense();
        if (budget_id) this.expenseForm.budget_id = budget_id;
        this.showExpenseEditor = true;
        this.service.render();
    }
    public openExpenseEdit(e: any) {
        this.editingExpense = e;
        this.expenseForm = { ...e, budget_id: e.budget_id || '' };
        this.showExpenseEditor = true;
        this.service.render();
    }
    public closeExpenseEditor() { this.showExpenseEditor = false; this.service.render(); }
    public async submitExpense() {
        if (!this.expenseForm.title) { this.service.alert.show({ title: '오류', message: '지출 제목을 입력하세요' }); return; }
        const payload: any = { ...this.expenseForm };
        payload.amount = Number(payload.amount) || 0;
        const res = await wiz.call('upsert_expense', { program_id: this.program_id, id: this.editingExpense?.id || '', data: JSON.stringify(payload) });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '저장 실패' }); return; }
        this.showExpenseEditor = false;
        await this.loadBudgets();
    }
    public async deleteExpense(e: any) {
        const ok = await this.service.alert.show({
            title: '지출 삭제', message: `"${e.title}" 지출을 삭제하시겠습니까?`,
            action: '삭제', actionBtn: 'error', cancel: '취소'
        });
        if (!ok) return;
        const res = await wiz.call('delete_expense', { id: e.id });
        if (res.code !== 200) { this.service.alert.show({ title: '오류', message: res.data?.message || '삭제 실패' }); return; }
        await this.loadBudgets();
    }
    public async filterExpenses() {
        this.expensePage = 1;
        await this.loadExpenses();
    }
}

// FN-20260508-0035 Budget Management is appended via class merging — moved into class above

export default PortalLpsysadminSupportProgramItemComponent;